import { PublishModal } from './PublishModal';

export function preloadPublishModal(saveDraft?: () => void) {
	saveDraft?.();

	const preloadBackgroundImgLight = async () =>
		await import(
			/* webpackChunkName: "loadable-PublishModalPublish-Modal-Background-Image-Light-svg" */ './PublishModal/Publish-Modal-Background-Image-Light.svg'
		);
	const preloadBackgroundImgDark = async () =>
		await import(
			/* webpackChunkName: "loadable-PublishModalPublish-Modal-Background-Image-Dark-svg" */ './PublishModal/Publish-Modal-Background-Image-Dark.svg'
		);

	void PublishModal.preload();
	void preloadBackgroundImgLight();
	void preloadBackgroundImgDark();
}
